import BasketSendOffer from './TagManager/BasketSendOffer';
import BsClass from './TagManager/BSClass';
import CarQuickQuote from './TagManager/CarQuickQuote';
import CprConsentModal from './TagManager/CprConsentModal';
import CreateMember from './TagManager/CreateMember';
import EcommerceClass from './TagManager/EcommerceClass';
import ImageWithLink from './TagManager/ImageWithLink';
import NavigationList from './TagManager/NavigationList';
import NBA from './TagManager/NBA';
import Newsletter from './TagManager/Newsletter';
import NewsletterSignupModal from './TagManager/NewsletterSignupModal';
import Notifications from './TagManager/Notifications';
import PolicySection from './TagManager/PolicySection';
import PolicyView from './TagManager/PolicyView';
import ReportClaim from './TagManager/ReportClaim';
import TopStory from './TagManager/TopStory';
import QuickQuoteFlow from './TagManager/QuickQuoteFlow';
import QuickQuoteFlowHealth from './TagManager/QuickQuoteFlow_Health';
import PaymentTerm from './TagManager/PaymentTerm';
import ProposalBasket from './TagManager/ProposalBasket';
import Proposal from './TagManager/Proposal';
import PopUp from './TagManager/PopUp';
import GreenCard from './TagManager/GreenCard';
import CviHeader from './TagManager/CviHeader';

export default class TagManager {
    constructor(payload) {
        this.gtmObject = null;
        this.vm = payload.vm;
        this.id = payload.id;
        this.data = payload.data;
        this.event = payload.event;
        this.populateGtmObject();
    }

    populateGtmObject() {
        let gtmObject = null;

        const carQuickQuote = new CarQuickQuote(this.vm);
        const cprConsentModal = new CprConsentModal(this.vm);
        const createMember = new CreateMember(this.vm);
        const policySection = new PolicySection(this.vm);
        const reportClaim = new ReportClaim(this.vm);
        const policyView = new PolicyView(this.vm);
        const newsletter = new Newsletter(this.vm);
        const ecommerce = new EcommerceClass(this.vm);
        const bsclass = new BsClass();
        const notifications = new Notifications(this.vm);
        const paymentTerm = new PaymentTerm(this.vm);
        
        switch (this.id) {
            case 'basketSendOffer':
                gtmObject = new BasketSendOffer(this.vm).get(this.event);
                break;
            case 'createMember':
                gtmObject = createMember.get(this.event);
                break;
            case 'cprConsentModal':
                gtmObject = cprConsentModal.get(this.event);
                break;
            case 'quickQuoteCar':
                gtmObject = carQuickQuote.get(this.event);
                break;
            case 'policySection':
                gtmObject = policySection.get(this.event);
                break;
            case 'policyView':
                gtmObject = policyView.get(this.event);
                break;
            case 'reportClaim':
                gtmObject = reportClaim.get(this.event);
                break;
            case 'imageWithLink':
                gtmObject = new ImageWithLink(this.vm).get(this.event);
                break;
            case 'navigationList':
                gtmObject = new NavigationList(this.vm).get(this.event);
                break;
            case 'nba':
                gtmObject = new NBA(this.vm).get(this.event);
                break;
            case 'newsletter':
                gtmObject = newsletter.get(this.event);
                break;
            case 'newsletterSignupModal':
                gtmObject = new NewsletterSignupModal(this.vm).get(this.event);
                break;
            case 'ecommerce':
                gtmObject = ecommerce.get(this.event);
                break;
            case 'bs':
                gtmObject = bsclass.get(this.event);
                break;
            case 'notifications':
                gtmObject = notifications.get(this.event);
                break;
            case 'topStory':
                gtmObject = new TopStory(this.vm).get(this.event);
                break;
            case 'quickQuoteFlow':
                gtmObject = new QuickQuoteFlow(this.vm).get(this.event);
                break;
            case 'healthQuickQuote':
                gtmObject = new QuickQuoteFlowHealth(this.vm).get(this.event);
                break;
            case 'paymentTerm':
                gtmObject = paymentTerm.get(this.event);
                break;
            case 'proposalBasket':
                gtmObject = new ProposalBasket(this.vm).get(this.event);
                break;
            case 'proposalBasketProposal':
                gtmObject = new Proposal(this.vm).get(this.event);
                break;
            case 'popUp':
                gtmObject = new PopUp(this.vm).get(this.event);
                break;
            case 'greenCard':
                gtmObject = new GreenCard().get(this.event);
                break;
            case 'cviHeader':
                gtmObject = new CviHeader(this.vm).get(this.event);
                break;
            default:
                break;
        }

        if (gtmObject !== null) {
            this.gtmObject = gtmObject;
        }
    }

    getGtmObject() {
        return this.gtmObject;
    }
}
